/**
 * Previsualizacion completa: la historia entera, de arriba abajo.
 *
 * Compone las mismas vistas que cada pestana muestra al lado de sus campos
 * (`vistas.jsx`), en el orden en que el lector las encuentra. No duplica nada:
 * si una vista cambia, cambia en los dos lugares.
 *
 * La pestana anterior describia la historia con texto —"Imagen: https://…"—,
 * que es justo lo que el handoff prohibe: si no se ve el componente, no es una
 * previsualizacion.
 *
 * Spec: docs/superpowers/specs/2026-08-26-editorial-design-system-design.md §5
 */
import React from 'react';

import {
  Rotulo,
  VistaCaso,
  VistaCuerpo,
  VistaMedio,
  VistaPortada,
  VistaProducto,
} from './vistas';

export default function Previsualizacion({ form, productos = [] }) {
  const esB2B = form.categoria === 'B2B';

  return (
    <div style={{ display: 'grid', gap: 40 }}>
      <section>
        <Rotulo nota="Lo primero que ve el lector, en la home y en la página de la historia.">
          Portada
        </Rotulo>
        <VistaPortada form={form} />
      </section>

      <section>
        <Rotulo nota="El artículo, con su ficha de números si la tiene.">Cuerpo</Rotulo>
        <VistaCuerpo form={form} />
      </section>

      <section>
        <Rotulo nota="Bloque opcional entre el cuerpo y la banda de producto.">
          Editorial intermedio
        </Rotulo>
        <VistaMedio form={form} />
      </section>

      {esB2B ? (
        <section>
          <Rotulo nota="Cómo aparece esta historia en /business.">Caso B2B</Rotulo>
          <VistaCaso form={form} />
        </section>
      ) : null}

      <section>
        <Rotulo nota="Cierra la página, con el botón que lleva al simulador.">
          Producto relacionado
        </Rotulo>
        <VistaProducto form={form} productos={productos} />
      </section>
    </div>
  );
}
